import React from 'react';
import { connect } from 'react-redux';

import { CardElement, Elements, injectStripe, CardNumberElement, StripeProvider, DepositElements } from 'react-stripe-elements';
import { Form } from 'reactstrap';
import BankTransferPayment from './BankTransferPayment';
import CashPayment from './CashPayment';
import ChequePayment from './ChequePayment';
import CreditCardPayment from './CreditCardPayment';
import CorporatePayNow from './CorporatePayNow';
import { SGBC_STRIPE_PK } from '../../../../../config';

import MandatoryStar from 'cyder/forms/MandatoryStar';

class PaymentChoicesPanel extends React.Component {
    render() {
        return (
            <StripeProvider apiKey={SGBC_STRIPE_PK}>
                <Elements>
                    <React.Fragment>
                        {this.props.paymentMode === 1 && (
                            <ChequePayment
                                onDateChanged={this.props.onDateChanged}
                                onTextChanged={this.props.onTextChanged}
                                paymentInfo={this.props.paymentInfo}
                            />
                        )}
                        {this.props.paymentMode === 2 && (
                            <BankTransferPayment
                                onDateChanged={this.props.onDateChanged}
                                onTextChanged={this.props.onTextChanged}
                                paymentInfo={this.props.paymentInfo}
                            />
                        )}
                        {this.props.paymentMode === 3 && (
                            <CashPayment
                                onDateChanged={this.props.onDateChanged}
                                onTextChanged={this.props.onTextChanged}
                                paymentInfo={this.props.paymentInfo}
                            />
                        )}
                        {this.props.paymentMode === 4 && (
                            <CreditCardPayment
                                applicationInfo={this.props.applicationInfo}
                                paymentInfo={this.props.paymentInfo}
                                back={this.props.back}
                                cancel={this.props.cancel}
                                dialogModalToggle={this.props.dialogModalToggle}
                            />
                        )}
                        {this.props.paymentMode === 5 && <CorporatePayNow paymentInfo={this.props.paymentInfo} />}
                    </React.Fragment>
                </Elements>
            </StripeProvider>
        );
    }
}

export default PaymentChoicesPanel;
